import React from 'react';
import projectModel from './model/projectModel';
import { SelectBasePrototype } from 'clad';

export const SelectProject = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder, labelInValue } = props;

    const handleFetch = ({ query, id, pagination }) => {
        return projectModel.list({ query, id, pagination });
    };

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a project')}
            schema={{ idOption: 'mid', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
            labelInValue={labelInValue || false}
        />
    );
});
